import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
	selector: 'app-game-layout',
	imports: [RouterOutlet],
	templateUrl: './game-layout.html',
	styleUrl: './game-layout.scss'
})
export class GameLayout {
	// This layout handles game components with full width and height
}
